import { Grid2 } from "@mui/material";
import { getImageUrl } from "../../utils/getImageUrl";

export const SummerCampImageCom = ({ itemData }) => {
    if (!itemData || itemData.length === 0) return null;

    const bgImage = (url) => ({
        backgroundImage: `url(${getImageUrl(url)})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        borderRadius: 1
    });

    return (
        <Grid2 container spacing={"0.7rem"}>

            {/* LEFT LARGE IMAGE */}
            <Grid2
                size={{ xs: 6, sm: 4, md: 4 }}
                sx={{
                    ...bgImage(itemData[0]?.img),
                    height: { xs: 300, sm: 350, md: 460 },
                }}
            />

            {/* TWO STACKED IMAGES */}
            <Grid2
                size={{ xs: 6, sm: 4, md: 4 }}
                container
                sx={{ flexDirection: "column", height: { xs: 300, sm: 350, md: 460 }, }}
            >
                {itemData?.slice(1, 3).map((item, index) => (
                    <Grid2
                        key={index}
                        size={12}
                        sx={{
                            flex: 1,
                            ...bgImage(item?.img),
                        }}
                    />
                ))}
            </Grid2>

            {/* RIGHT LARGE IMAGE (same as left) */}
            <Grid2
                size={{ xs: 12, sm: 4, md: 4 }}
                sx={{
                    ...bgImage(itemData[3]?.img),
                    height: { xs: 300, sm: 350, md: 460 },
                }}
            />
        </Grid2>
    );
};
